<div class="container text-left">
  <div class="container">
    <form [formGroup]="form">
      <h3 class="subtitulo">Processo</h3>
      <div class="form-row">
        <div class="col-7">
          <app-nro-processo-input formControlName="nroProcesso" [tokenIam]="tokenIam" tipoOrdem="BAIXA"></app-nro-processo-input>
        </div>
      </div>

      <div class="form-dados-ordem">

        <app-sla-selector [form]="form"></app-sla-selector>

        <app-lista-titulares [titulares]="titulares" [tipoOrdem]='"BAIXA"' (titularesChange)="onTitularesChange($event)"></app-lista-titulares>

        <app-lista-credores [credores]="credores" (credoresChange)="onCredoresChange($event)"></app-lista-credores>

        <div class="form-row autor-reu">
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="inputs">
              <mat-label>Autor</mat-label>
              <mat-select
                formControlName="autor"
                (selectionChange)="filterEnvolvidos()"
                placeholder="Autor"
                [attr.data-cy]="'select-autor'"
              >
                <mat-option *ngFor="let envolvido of envolvidosAutor" [value]="envolvido.nome" [attr.data-cy]="'option-autor-' + envolvido.nome">
                  {{ envolvido.nome }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="autor.hasError('required')">
                Nome do autor / Exequente é <strong>obrigat&oacute;rio</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="inputs">
              <mat-label>Réu</mat-label>
              <mat-select
                formControlName="reu"
                (selectionChange)="filterEnvolvidos()"
                placeholder="Réu"
                [attr.data-cy]="'select-reu'"
              >
                <mat-option *ngFor="let envolvido of envolvidosReu" [value]="envolvido.nome" [attr.data-cy]="'option-reu-' + envolvido.nome">
                  {{ envolvido.nome }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="reu.hasError('required')">
                Nome do réu / executado é <strong>obrigat&oacute;rio</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="link-limpar">
            <a (click)="limparAutorReu()" class="link-limpar">
              Limpar
            </a>
          </div>
        </div>

        <div class="row ">
          <div class="col-sm-7"></div>
          <div class="col-sm-5">
            <app-acao-buttons
              [tipoOrdem]="'BAIXA'"
              (onConfirmar)="baixarOrdem()"
            ></app-acao-buttons>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
